<template>
    <div :class="className" class="rounded bg-gray-200 flex flex-row py-3 px-2 items-center gap-x-2">
        <ExclamationIcon class="text-gray-500 !w-6 !h-6"></ExclamationIcon>
        <p class="text-sm contacting-5 font-normal text-gray-800">
            <slot></slot>
        </p>
    </div>
</template>
<script lang="ts" setup>
import { ExclamationIcon } from "@heroicons/vue/outline"

interface Props {
    className?: string
}

defineProps<Props>()
</script>
